import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
	esp: (
		`
		<h4 class="mb-3 bold text-center">Albatroso</h4>

		<div class="poem">
			<p class="poem-block mb-3">
				Dum longa navigad’ <br/>
				Devoras splen’ matrosojn, <br/>
				Enue pasas temp’ – <br/>
				Kaj por amuzi sin <br/>
				Birdegojn de la mar’ – <br/>
				Majestajn albatrosojn – <br/>
				Kaptadas ŝipanar’, <br/>
				Ludante kun destin’.
			</p>

			<p class="poem-block mb-3">
				Heroldo de ĉiel’, <br/>
				La reĝo de l’ lazuro, <br/>
				Li ŝvebas en aer’ <br/>
				Kun gajo kaj delic’, <br/>
				Kaj sekvas ŝipon li <br/>
				Libere, en plezuro, <br/>
				Sed falas al ferdek’, <br/>
				Kaptita pro kapric’.
			</p>

			<p class="poem-block mb-3">
				Kaj jen flugiloj du <br/>
				Per kiuj dum tempesto <br/>
				La nubojn ŝiris li <br/>
				Kun fulmoj en konkur’, <br/>
				Humile sternas sin <br/>
				Post la senhelpa besto, <br/>
				Kaj ĉiuj mokas lin, <br/>
				Ĝuante pro tortur’.
			</p>

			<p class="poem-block mb-3">
				Spirito de liber’, <br/>
				Li iĝis homa predo. <br/>
				Fluginta kiel vent’ – <br/>
				Li lamas sur ferdek’. <br/>
				Kaj henas ĉiuj dum <br/>
				La fum’ de cigaredo <br/>
				Incitas ĝene lin, <br/>
				Blovita al la bek’.
			</p>

			<p class="poem-block mb-3">
				Dum longa navigad’ <br/>
				Devoras splen’ matrosojn, <br/>
				Enue pasas temp’ – <br/>
				Kaj por amuzi sin <br/>
				Birdegojn de la mar’ – <br/>
				Majestajn albatrosojn – <br/>
				Kaptadas ŝipanar’, <br/>
				Ludante kun destin’.
			</p>
		</div>
	`
	)
}

const itemName = {
	esp: 'Charles Baudelaire'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;